import { ReactNode } from 'react'
import { Navigate } from 'react-router'
import { useAuth } from './AuthContext'

// Wraps a route element, redirecting to /login if no token is stored. The
// axios response interceptor (client.ts) handles the complementary case —
// a token that's present but expired/invalid, discovered when an API call
// 401s — by clearing storage and doing a hard redirect there too.
export default function RequireAuth({ children }: { children: ReactNode }) {
  const { token } = useAuth()
  if (!token) {
    return <Navigate to="/login" replace />
  }
  return <>{children}</>
}
